import { gameState, inventoryState, playerState } from "../state/stateManager";
import { goToScene } from "../main";
import {
  checkFirstSale,
  createGainedItem,
  getBrandAwarenessConversion,
  sendAlert,
} from "../utils";
import { Resources } from "../Resources";

import { Player } from "../player";
import InventoryHUD from "../ui/inventory";
import sugar from "./../../res/sugar.png";
import BigBen from "../actors/characters/bigBen";
import Box from "./../../res/box.png";
import Extractor from "./../../res/extractor.png";
import Bee from "./../../res/bee.png";
import HippyChick from "../actors/characters/hippyChick";
import { Keys, Scene } from "excalibur";
export default class BeeClubCommerce extends Scene {
  constructor() {
    super();

    this.active = 0;
    this.sellHoney = false;
    this.selected = false;
    this.cashout = false;
    const player = new Player(31 * 16, 15 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 6;
    this.player.wearingVeil = false;
    this.hippy = new HippyChick({ x: 32 * 16, y: 12 * 16 }, "beeClubCommerce");
    this.hippy.z = 4;
    this.hippy.cutScene = true;
    this.player.cutScene = true;
  }
  onActivate(engine) {
    this.inventory = inventoryState.getInventory();
    this.coins = gameState.getCoins();
    Resources.BeeClubMap.addToScene(this);

    this.add(this.player);
    this.add(this.hippy);

    this.camera.strategy.lockToActor(this.player);
    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.classList.add("commerce");
    this.menuContainer.classList.add("beeMarketCommerce");
    this.menuContainer.style.display = "flex";
    this.menu = document.getElementById("feed-menu");
    console.log("menu: ", this.menu);
    this.menu.style.display = "block";
    this.drawMenu();
    this.inventoryHUD = new InventoryHUD("beeClubCommerce");
    this.getProducts();
  }
  drawMenu() {
    console.log("inside drawmenu: ", this.active);

    if (this.active == 0) {
      this.menu.innerHTML = `<h1>Bee Club Market</h1>
        
        <ul>
            <li id="list0" class="productLi"><img class="productImage" src="${Bee}"/><span id="selector">></span>Bees</li>
            <li id="list1" class="productLi"><img  class="productImage" src="${Box}"/>Boxes</li>
            <li id="list2" class="productLi"><img  class="productImage" src="${Extractor}"/>Extractors</li>
          </ul>
       
        `;
    } else if (this.active == 1) {
      this.menu.innerHTML = `<h1>Bee Club Market</h1>
       
        <ul>
            <li id="list0" class="productLi"><img  class="productImage" src="${Bee}"/>Bees</li>
            <li id="list1" class="productLi"><img  class="productImage" src="${Box}"/><span id="selector">></span>Boxes</li>
            <li id="list2" class="productLi"><img  class="productImage" src="${Extractor}"/>Extractors</li>
          </ul>
       
        `;
    } else if (this.active == 2) {
      this.menu.innerHTML = `<h1>Bee Club Market</h1>
          
          <ul>
              <li id="list0" class="productLi"><img  class="productImage" src="${Bee}"/>Bees</li>
              <li id="list1" class="productLi"><img  class="productImage" src="${Box}"/>Boxes</li>
              <li id="list2" class="productLi"><img  class="productImage" src="${Extractor}"/><span id="selector">></span>Extractors</li>
            </ul>
         
          `;
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      Resources.Click.play(2);

      if (this.active == 0) {
        this.active = 2;
      } else {
        this.active = this.active - 1;
      }
      if (this.selected) {
        this.openBuyBeesMenu();
      } else {
        this.drawMenu();
      }
    }

    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play(2);

      console.log("active : ", this.active);
      if (this.active == 2) {
        this.active = 0;
      } else {
        this.active++;
      }
      if (this.selected) {
        this.openBuyBeesMenu();
      } else {
        this.drawMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      if (this.active == 0) {
        this.selected = true;
        this.buyBees = true;
        this.buyBoxes = false;
        this.buyExtractors = false;
        this.openBuyBeesMenu();
      } else if (this.active == 1) {
        this.selected = true;
        this.buyBoxes = true;
        this.buyBees = false;
        this.buyExtractors = false;
        this.openBuyBoxesMenu();
      } else if (this.active == 2) {
        this.selected = true;
        this.buyExtractors = true;
        this.buyBees = false;
        this.buyBoxes = false;
        this.openBuyExtractorsMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      if (this.selected) {
        this.drawMenu();
        this.sellHoney = false;
        this.buyItems = false;
        this.selected = false;
      } else {
        this.selected = false;
        this.sellHoney = false;
        this.buyItems = false;
        goToScene("beeClub");
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Space)) {
      let inventory = inventoryState.getInventory();
      let coins = gameState.getCoins();
      let content = playerState.getContent();
      if (this.buyBees) {
        //purchase selected bee

        let beesToBuy = content.beeClubMarket.items.bees[this.active];
        if (beesToBuy == undefined || beesToBuy == null) {
          sendAlert("Nothing To Purchase");
          return;
        }
        console.log(
          "should buy: ",
          beesToBuy,
          "coins: ",
          coins,
          " price: ",
          beesToBuy.price
        );
        if (coins >= beesToBuy.price) {
          if (beesToBuy.type == "nuc") {
            //push type to inventory nucs
            inventory.nucs.push({ breed: beesToBuy.breed });
            coins = coins - beesToBuy.price;
            gameState.setCoins(coins);
            createGainedItem(`Bees: ${beesToBuy.breed} ${beesToBuy.type}`);
            Resources.Coins.play();
          } else if (beesToBuy.type == "package") {
            //push type to inventory packages
            inventory.packages.push({ breed: beesToBuy.breed });
            coins = coins - beesToBuy.price;
            gameState.setCoins(coins);
            createGainedItem(`Bees: ${beesToBuy.breed} ${beesToBuy.type}`);

            Resources.Coins.play();
          }
          content.beeClubMarket.items.bees.splice([this.active], 1);
          this.openBuyBeesMenu();
        } else {
          Resources.Error.play();
          sendAlert("Not Enough Coins");
        }
      } else if (this.buyBoxes) {
        if (coins >= 45) {
          inventory.boxes++;
          coins = coins - 45;
          Resources.Coins.play();
          gameState.setCoins(coins);
          createGainedItem("Hive Box");
        } else {
          Resources.Error.play();
          sendAlert("Not Enough Coins");
        }
      }
      this.inventoryHUD.display();
    }
  }
  onDeactivate() {
    this.menuContainer.style.display = "none";
    this.menu.style.display = "none";
    this.menuContainer.classList.remove("commerce");
    this.inventoryHUD.destroy();
  }
  getProducts() {
    let content = playerState.getContent();

    if (content.beeClubMarket.lastPerused == null) {
      //get first offerings
      let bees = [];
      let bee1 = {
        seller: "Amelia",
        breed: "kozmanian",
        type: "nuc",
        price: 120,
      };
      let bee2 = {
        seller: "Amelia",
        breed: "commercial",
        type: "nuc",
        price: 100,
      };
      let bee3 = {
        seller: "Marcus",
        breed: "maryEllen",
        type: "package",
        price: 135,
      };
      bees.push(bee1);
      bees.push(bee2);
      bees.push(bee3);
      content.beeClubMarket.items.bees = bees;
    } else {
      let now = new Date().getTime();
      let timePassed = now - content.beeClubMarket.lastPerused;
      let speed = gameState.getGameSpeed();
      let transTime = speed * timePassed;
      let hours = transTime / 3600000;
      console.log("time passed: ", hours, " hours");
      if (hours > 160) {
        //get new offerings
        let bees = [];
        let bee1 = {
          seller: this.getRandomSeller(),
          type: "nuc",
          price: this.getRandomPrice(),
          breed: this.getRandomBees(),
        };
        let bee2 = {
          seller: this.getRandomSeller(),
          type: "package",
          price: this.getRandomPrice(),
          breed: this.getRandomBees(),
        };
        let bee3 = {
          seller: this.getRandomSeller(),
          type: "nuc",
          price: this.getRandomPrice(),
          breed: this.getRandomBees(),
        };
        bees.push(bee1);
        bees.push(bee2);
        bees.push(bee3);
        content.beeClubMarket.items.bees = bees;
      }
    }
    content.beeClubMarket.lastPerused = new Date().getTime();
  }

  getRandomPrice() {
    let prices = [
      90, 140, 150, 175, 150, 145, 140, 120, 145, 110, 100, 150, 160, 175, 150,
      100, 150, 120, 125, 145, 140, 135, 150,
    ];
    const randomIndex = Math.floor(Math.random() * prices.length);
    return prices[randomIndex];
  }
  getRandomBees() {
    let types = [
      "kozmanian",
      "kozUniversity",
      "rosk",
      "maryEllen",
      "commercial",
      "furdland",
    ];
    const randomIndex = Math.floor(Math.random() * types.length);
    return types[randomIndex];
  }
  getRandomSeller() {
    let sellers = [
      "Amelia",
      "Marcus",
      "Bill",
      "Mick",
      "Charlie",
      "Dennis",
      "Mac",
      "Frank",
      "Dee",
    ];
    const randomIndex = Math.floor(Math.random() * sellers.length);
    return sellers[randomIndex];
  }
  openBuyBeesMenu() {
    let content = playerState.getContent();
    let bees = content.beeClubMarket.items.bees;
    this.menu.innerHTML = `<h1>Bee Club Market</h1>
        <h3>Space: Buy Item</h3>
        <ul class="beeMarket">
            ${
              bees.length > 0
                ? bees.map((bee, i) => {
                    return `<li id="list${i}">${
                      this.active == i ? '<span id="selector">></span>' : ""
                    } <img src="${Bee}"/><p>Seller: ${
                      bee.seller
                    }</p> <p>Breed: ${bee.breed}</p> <p>Type: ${
                      bee.type
                    }</p> <p>Price: ${bee.price}</p></li>`;
                  })
                : "<h3>NONE AVAILABLE</h3>"
            }
          </ul>
       
        `;
  }
  openBuyBoxesMenu() {
    this.menu.innerHTML = `<h1>Bee Club Market</h1>
    <h3>Space: Buy Item</h3>
    <p><img src="${Box}"/>Hive Box: $45</p>
   
    `;
  }
  openBuyExtractorsMenu() {
    this.menu.innerHTML = `<h1>Bee Club Market</h1>
    <h3>None Available</h3>
    
   
    `;
  }
}
